import React from "react";
import {
  Image,
  Text,
  View,
  Page,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import logo from "../../../assets/images/brand/login_logo.png";
import seal from "../../../assets/images/brand/Company Seal.jpg";
import QRCode from "react-qr-code";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB");
};

const formattedAmount = (amount) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
  }).format(amount);

const EditQuickInvoicePdf = ({ data }) => {
  Font.register({
    family: "Open Sans",
    src: require("../../../assets/fonts/OpenSans-Regular.ttf"),
  });
  Font.register({
    family: "Open Sans Bold",
    src: require("../../../assets/fonts/OpenSans-Bold.ttf"),
  });

  const styles = StyleSheet.create({
    page: {
      fontSize: 9,
      padding: 25,
      fontFamily: "Open Sans",
      lineHeight: 1.4,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingBottom: 6,
    },
    logo: { width: 120, height: "auto" },
    companyLogo: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
    },
    title: {
      fontSize: 16,
      fontFamily: "Open Sans Bold",
      marginTop: 6,
      marginBottom: 4,
    },
    companyInfo: { textAlign: "right" },
    section: { marginTop: 10, marginBottom: 6 },
    bold: { fontFamily: "Open Sans Bold" },
    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 2,
    },
    twoColumn: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderWidth: 1,
    },
    column: { flex: 1, paddingRight: 10 },
    metaBlock: { flexDirection: "row", flexWrap: "wrap", marginTop: 6 },
    metaItem: { width: "33%", marginBottom: 2 },
    table: { marginTop: 5, borderWidth: 1, borderColor: "#000" },
    tableHeader: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "#000",
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "#000",
      minHeight: 22,
      alignItems: "center",
    },
    cell: {
      borderRightWidth: 1,
      borderColor: "#000",
      padding: 3,
      textAlign: "center",
    },
    noBorderRight: { borderRightWidth: 0 },
    totalRow: {
      flexDirection: "row",
      backgroundColor: "#d3d3d3",
      borderTopWidth: 1,
      borderColor: "#000",
    },
    amountInWords: { marginTop: 5, fontFamily: "Open Sans Bold" },
    bankSection: { marginTop: 10 },
    small: { fontSize: 8 },
    // footer: {
    //   position: "absolute",
    //   bottom: 20,
    //   fontSize: 8,
    //   left: 25,
    //   right: 25,
    //   textAlign: "right",
    // },
    label: { width: "50%", fontSize: 8 },
    labelSpan: { width: "100%", fontSize: 8 },
    text: { width: "50%", fontSize: 8 },
    headerText: { fontSize: 6, fontFamily: "Open Sans Bold" },
    headerCol: {
      borderRightWidth: 1,
      textAlign: "center",
      flexDirection: "column",
      justifyContent: "center",
    },
    headerColEnd: {
      textAlign: "center",
      flexDirection: "column",
      justifyContent: "center",
    },
    dataCol: {
      borderRightWidth: 1,
      textAlign: "center",
      flexDirection: "column",
      fontFamily: "Open Sans",
      justifyContent: 'center'
    },
    dataColEnd: { textAlign: "center", flexDirection: "column", justifyContent: 'center' },
    wordRow: { flexDirection: "row", justifyContent: "space-between" },
    bankLeft: { borderRightWidth: 1, padding: 2 },
    bankRow: { flexDirection: "row", fontSize: 6 },
    bankRight: {},
    bankRightTop: { padding: 2 },
    bottomRow: { padding: 3 },
    para: { flexDirection: "column" },
    paragraph: { fontSize: 7, fontFamily: "Open Sans" },
    leftTextCol: { textAlign: "left", paddingLeft: 2 },
    footerCell: { fontSize: 6, fontFamily: "Open Sans Bold" },
    centerCol: {
      flexDirection: "row",
      alignItems: "center",
      textAlign: "center",
      justifyContent: "center",
    },
    qrImage: {
      width: 70,
      height: 70,
      position: "absolute",
      bottom: 30,
      right: 15,
    },
    pageNumber: {
      position: "absolute",
      top: 810,
      left: 0,
      right: 20,
      textAlign: "right",
      fontSize: 8,
      color: "gray",
    },
  });

  const totalAmount = data[1]?.reduce((sum, v) => {
    const price = v?.total_price || 0;
    return sum + price;
  }, 0);

  const amountInWords = `JPY ${formattedAmount(totalAmount)} ONLY`;

  return (
    <Document>
      {/* PAGE 1 */}
      <Page size="A4" style={styles.page}>
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `Page ${pageNumber} of ${totalPages}`
        )} fixed />
        {/* HEADER */}
        <View style={styles.header}>
          <View style={styles.companyInfo}>
            <Text style={styles.bold}>
              J and A TRADING CORPORATION PVT, LTD
            </Text>
            <Text>5-4-7 INAEI , MINATO KU,</Text>
            <Text>NAGOYA, JAPAN 455-0842</Text>
            <Text>TEL : 052-355-6153 FAX : 052-355-6154</Text>
            <Text>EMAIL : jandatrading@waltz.ocn.ne.jp</Text>
            <Text>WEB : www.jandatrading.jp</Text>
            <Text>CORPORATE NUMBER: 1180001019608</Text>
          </View>
          <View style={styles.companyLogo}>
            <Image style={styles.logo} src={logo} />
            <Text style={styles.title}>PROFORMA INVOICE</Text>
          </View>
        </View>

        {/* CONSIGNEE / NOTIFY PARTY */}
        <View style={[styles.twoColumn, styles.section]}>
          <View style={{ flex: 2, borderRightWidth: 1 }}>
            <View style={{ marginBottom: 10, height: 80 }}>
              <Text
                style={{
                  marginBottom: 8,
                  borderBottom: 1,
                  fontFamily: "Open Sans Bold",
                  padding: 2,
                  fontSize: 8,
                }}
              >
                CONSIGNEE:
              </Text>
              <View style={{ paddingLeft: 4 }}>
                <Text>{data[0]?.bill_to_name}</Text>
                <Text>{data[0]?.address_line_1}</Text>
                <Text>{data[0]?.address_line_2}</Text>
                <Text>{data[0]?.city}</Text>
                <Text>{data[0]?.bill_to_email}</Text>
                <Text>{data[0]?.bill_to_phone_number}</Text>
              </View>
            </View>
            {/* Notify Party */}
            <View style={{ marginBottom: 10, height: 80 }}>
              <Text
                style={{
                  marginBottom: 8,
                  borderBottom: 1,
                  borderTop: 1,
                  marginTop: 0,
                  fontFamily: "Open Sans Bold",
                  padding: 2,
                  fontSize: 8,
                }}
              >
                NOTIFY PARTY:
              </Text>
              <View style={{ paddingLeft: 4 }}>
                <Text>{data[0]?.notify_name ? data[0]?.notify_name : data[0]?.bill_to_name}</Text>
                <Text>{data[0]?.notify_address_line_1 ? data[0]?.notify_address_line_1 : data[0]?.address_line_1}</Text>
                <Text>{data[0]?.address_line_2 ? data[0]?.address_line_2 : data[0]?.address_line_2}</Text>
                <Text>{data[0]?.notifY_city ? data[0]?.notifY_city : data[0]?.city}</Text>
                <Text>{data[0]?.notify_to_email ? data[0]?.notify_to_email : data[0]?.bill_to_email}</Text>
                <Text>{data[0]?.notify_to_phone_number ? data[0]?.notify_to_phone_number : data[0]?.bill_to_phone_number}</Text>
              </View>
            </View>
          </View>

          {/* Second Column (3/5 width) */}
          <View style={{ flex: 4, flexDirection: "column" }}>
            {/* Top Row (2 columns) */}
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                borderBottomWidth: 1,
              }}
            >
              <View
                style={{
                  width: "50%",
                  borderRightWidth: 1,
                  paddingRight: 5,
                  paddingLeft: 5,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                    paddingTop: 5,
                  }}
                >
                  <Text style={styles.label}>DATE </Text>
                  <Text style={styles.text}>: {data[0]?.invoice_date}</Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                  }}
                >
                  <Text style={styles.label}>PROFORMA INVOICE </Text>
                  <Text style={styles.text}>: {data[0]?.invoice_no}</Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                  }}
                >
                  <Text style={styles.label}>SHIPMENT TYPE</Text>
                  <Text style={styles.text}>: {data[0]?.shipment_type}</Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                  }}
                >
                  <Text style={styles.label}>INCOTERM</Text>
                  <Text style={styles.text}>: {data[0]?.incoterm}</Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                  }}
                >
                  <Text style={styles.label}>COUNTRY</Text>
                  <Text style={styles.text}>: {data[0]?.country}</Text>
                </View>
              </View>

              <View style={{ width: "50%", paddingRight: 5, paddingLeft: 5 }}>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                    paddingTop: 5,
                  }}
                >
                  <Text style={styles.label}>SALES AGENT</Text>
                  <Text style={styles.text}>: {data[3]?.full_name}</Text>
                </View>
                {/* <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginBottom: 5 }}>
                                    <Text style={styles.label}>VESSEL</Text>
                                    <Text style={styles.text}>: {data[0]?.vessel}</Text>
                                </View> */}
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                  }}
                >
                  <Text style={styles.label}>PORT OF LOADING</Text>
                  <Text style={styles.text}>: {data[0]?.port_loading}</Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                  }}
                >
                  <Text style={styles.label}>PORT OF UNLOADING</Text>
                  <Text style={styles.text}>: {data[0]?.port_unloading}</Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginBottom: 5,
                  }}
                >
                  <Text style={styles.label}>FINAL DESTINATION</Text>
                  <Text style={styles.text}>: {data[0]?.destination}</Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    paddingBottom: 10,
                  }}
                >
                  <Text style={styles.label}>CURRENCY</Text>
                  <Text style={styles.text}>: {data[0]?.currency}</Text>
                </View>
              </View>
            </View>

            {/* Bottom Row */}
            <View style={{ paddingTop: 5 }}>
              <Text style={[styles.labelSpan, { paddingLeft: 5 }]}>
                PAYMENT TERMS: {data[0]?.notes}
              </Text>
            </View>
          </View>
        </View>
        {/* VEHICLE TABLE */}
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <View style={[{ flex: 1 }, styles.headerCol]}>
              <Text style={styles.headerText}>SNO</Text>
            </View>
            <View style={[{ flex: 3 }, styles.headerCol]}>
              <Text style={styles.headerText}>CHASSIS NO</Text>
              <Text style={styles.headerText}>(STOCK ID)</Text>
              <Text style={styles.headerText}>ORIGIN</Text>
            </View>
            <View style={[{ flex: 4 }, styles.headerCol]}>
              <Text style={styles.headerText}>DESCRIPTION OF GOODS</Text>
            </View>
            <View style={[{ flex: 2 }, styles.headerCol]}>
              <Text style={styles.headerText}>MFG YEAR</Text>
            </View>
            <View style={[{ flex: 2 }, styles.headerCol]}>
              <Text style={styles.headerText}>ENGINE CC</Text>
            </View>
            <View style={[{ flex: 2 }, styles.headerCol]}>
              <Text style={styles.headerText}>QTY</Text>
            </View>
            <View style={[{ flex: 2 }, styles.headerCol]}>
              <Text style={styles.headerText}>FOB</Text>
            </View>
            <View style={[{ flex: 2 }, styles.headerCol]}>
              <Text style={styles.headerText}>FREIGHT</Text>
            </View>
            <View style={[{ flex: 2 }, styles.headerCol]}>
              <Text style={styles.headerText}>INSURANCE</Text>
            </View>
            <View style={[{ flex: 3 }, styles.headerColEnd]}>
              <Text style={styles.headerText}>TOTAL</Text>
            </View>
          </View>
          <View style={styles.tableHeader}>
            <Text
              style={[
                styles.headerText,
                { textAlign: "center", marginLeft: 20 },
              ]}
            >
              Used Vehicle(s)
            </Text>
          </View>
          {data[1]?.map((v, idx) => (
            <View style={styles.tableHeader} key={idx}>
              <View style={[{ flex: 1 }, styles.dataCol]}>
                <Text style={styles.headerText}>{idx + 1}</Text>
              </View>
              <View style={[{ flex: 3 }, styles.dataCol]}>
                <Text style={styles.headerText}>{v?.chassis_no}</Text>
                <Text style={styles.headerText}>({v?.stock_no})</Text>
                <Text style={styles.headerText}>
                  {v?.countryName ? v?.countryName : v?.country?.name}
                </Text>
              </View>
              <View style={[{ flex: 4 }, styles.dataCol]}>
                <Text style={[styles.headerText, styles.leftTextCol]}>
                  MAKE: {v?.makeName ? v?.makeName : v?.make?.name}
                </Text>
                <Text style={[styles.headerText, styles.leftTextCol]}>
                  MODEL: {v?.modelName ? v?.modelName : v?.model?.name}
                </Text>
                <Text style={[styles.headerText, styles.leftTextCol]}>
                  HS CODE: {v?.hs_code}
                </Text>
              </View>
              <View style={[{ flex: 2 }, styles.dataCol]}>
                <Text style={styles.headerText}>{v?.mfg_year}{(v?.mfg_month !== null && v?.mfg_month !== '00') && '-'}{(v?.mfg_month !== null && v?.mfg_month !== '00') && v?.mfg_month}</Text>
              </View>
              <View style={[{ flex: 2 }, styles.dataCol]}>
                <Text style={styles.headerText}>{v?.engine_capacity}cc</Text>
              </View>
              <View style={[{ flex: 2 }, styles.dataCol]}>
                <Text style={styles.headerText}>1</Text>
              </View>
              <View style={[{ flex: 2 }, styles.dataCol]}>
                <Text style={styles.headerText}>
                  {Number(v?.fob_cost || 0).toLocaleString("en-US")}
                </Text>
              </View>
              <View style={[{ flex: 2 }, styles.dataCol]}>
                <Text style={styles.headerText}>
                  {v?.freight?.toLocaleString("en-US") || 0}
                </Text>
              </View>
              <View style={[{ flex: 2 }, styles.dataCol]}>
                <Text style={styles.headerText}>
                  {v?.insurance?.toLocaleString("en-US") || 0}
                </Text>
              </View>
              <View style={[{ flex: 3 }, styles.dataColEnd]}>
                <Text style={styles.headerText}>
                  {v?.total_price?.toLocaleString("en-US") || 0}
                </Text>
              </View>
            </View>
          ))}
          {(() => {
            // get all vehicles
            const vehicles = data[1] || [];

            // calculate totals
            const totals = vehicles.reduce(
              (acc, v) => {
                const fob = Number(v?.fob_cost || 0);
                const freight = Number(v?.freight || 0);
                const insurance = Number(v?.insurance || 0);
                const selling = Number(v?.total_price || 0);

                acc.fobAndJna += fob;
                acc.freight += freight;
                acc.insurance += insurance;
                acc.selling += selling;

                return acc;
              },
              { fobAndJna: 0, freight: 0, insurance: 0, selling: 0 }
            );

            return (
              <View style={styles.tableHeader}>
                {/* <View style={[{ flex: 1 }, styles.dataCol]}></View>
                <View style={[{ flex: 2.95 }, styles.dataCol]}></View> */}
                <View style={[{ flex: 12 }, styles.dataCol, styles.centerCol]}>
                  <Text style={[styles.footerCell]}>Grand Total CIF</Text>
                </View>
                {/* quantity col – if you need sum of qty use reduce too, here just example */}
                <View style={[{ flex: 2 }, styles.dataCol, styles.centerCol]}>
                  <Text style={[styles.footerCell, { textAlign: "right" }]}>
                    {vehicles.length}
                  </Text>
                </View>
                {/* <View style={[{ flex: 2 }, styles.dataCol, styles.centerCol]}>
                  <Text style={[styles.footerCell]}>
                    {totals.fobAndJna.toLocaleString("en-US")}
                  </Text>
                </View>
                <View style={[{ flex: 2 }, styles.dataCol, styles.centerCol]}>
                  <Text style={[styles.footerCell]}>
                    {totals.freight.toLocaleString("en-US")}
                  </Text>
                </View> */}
                <View style={[styles.dataCol, styles.centerCol, { flex: 6, borderRight: 'none' }]}>
                  {/* <Text style={[styles.footerCell]}>
                    {totals.insurance.toLocaleString("en-US")}
                  </Text> */}
                </View>
                <View
                  style={[styles.dataColEnd, styles.centerCol, { flex: 3 }]}
                >
                  <Text style={[styles.footerCell]}>
                    {totals.selling.toLocaleString("en-US")}
                  </Text>
                </View>
              </View>
            );
          })()}
          <View style={[styles.tableHeader, styles.bankRow]}>
            <View style={[{ flex: 3.09 }, styles.bankLeft]}>
              <Text style={[styles.footerCell]}>SHIPPERS BANK DETAILS:</Text>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>ACCOUNT: </Text>
                <Text style={{ flex: 2 }}>{data[2]?.account_name}</Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>BANK:</Text>
                <Text style={{ flex: 2 }}>{data[2]?.bank_name}</Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>BRANCH:</Text>
                <Text style={{ flex: 2 }}>{data[2]?.branch}</Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>BRANCH CODE:</Text>
                <Text style={{ flex: 2 }}>{data[2]?.branch_code}</Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>ACCOUNT NO: </Text>
                <Text style={{ flex: 2 }}>{data[2]?.account_number}</Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>SWIFT CODE:</Text>
                <Text style={{ flex: 2 }}>{data[2]?.swift_code}</Text>
              </View>
            </View>
            <View style={[{ flex: 2 }, styles.bankRight]}>
              <View style={styles.bankRightTop}>
                <Text style={[styles.footerCell]}>SHIPPING MARKS & NO'S:</Text>
                <Text>{data[0]?.shipping_marks}</Text>
              </View>
              <View></View>
            </View>
          </View>
          <View style={[styles.tableHeader, styles.bottomRow]}>
            <View style={[{ flex: 3 }, styles.bottomRowLeft]}>
              <Text style={[styles.footerCell]}>TERMS & CONDITIONS</Text>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>
                  Latest shipment date: {formatDate(data[0]?.shipment_date)}
                </Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>
                  LC validity: {data[0]?.lc_validity_period} Days
                </Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>
                  Transhipment: {data[0]?.transhipment}
                </Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={{ flex: 1 }}>
                  Partial shipement: {data[0]?.partial_shipment}
                </Text>
              </View>
            </View>
            <View style={[{ flex: 2 }, styles.bottomRowRight]}>
              <View>
                <Text>J and A Trading Corporation Pvt. Ltd.</Text>
                <Image style={styles.logo} src={seal} />
              </View>
            </View>
          </View>
        </View>
        <Text style={[{ marginTop: 12 }, styles.bold]}>
          Terms and Conditions
        </Text>
        <View style={[{ marginTop: 4 }, styles.para]}>
          <Text style={styles.paragraph}>
            {" "}
            1. NEGOTIATING BANK IN JAPAN : ANY BANK{" "}
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            2. PORT OF LOADING : ANY PORT IN JAPAN
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            3. PORT OF DISCHARGE/UNLOADING : ANY PORT IN SRI LANKA
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            4. PAYMENT L/C AT SIGHT IN FULL INVOICE AMOUNT
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            5. TYPOGRAPHICAL & MINOR DISCREPANCIES ACCEPTABLE WITHOUT ANY
            CHARGES
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            6. APPLICANT BANK SHALL TRANSFER FUNDS WITHOUT ANY DISPUTE AND DELAY
            WITHIN 3 WORKING DAYS </Text><Text style={styles.paragraph}>{" "}{" "}{" "}{" "}{" "}AFTER RECEIVING THE DOCUMENTS TO THE BANK
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            7. PERIOD OF PRESENTATION OF DOCUMENTS WITHIN 21 DAYS AFTER
            SHIPMENT.
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            8. DISCREPENCY CHARGES WILL NOT BE BORNE BY THE BENEFICIARY.
          </Text>
          <Text style={styles.paragraph}>
            {" "}
            9. ANY CHARGES OUTSIDE JAPAN WILL NOT BE BORNE BY THE BENEFICIARY.
          </Text>
        </View>
        <Image style={styles.qrImage} src={data[5]} />
      </Page>
    </Document>
  );
};

export default EditQuickInvoicePdf;
